import { render, staticRenderFns } from "./ProductBlacklistControl.vue?vue&type=template&id=03387a45&"
import script from "./ProductBlacklistControl.vue?vue&type=script&lang=js&"
export * from "./ProductBlacklistControl.vue?vue&type=script&lang=js&"
import style0 from "./ProductBlacklistControl.vue?vue&type=style&index=0&id=03387a45&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports